<template>
  <v-card class="my-1">
    <v-toolbar flat dense>
      <v-toolbar-title>Leuchtring</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <div class="d-flex align-center mb-2">
        <span class="text-body-2 font-weight-medium">Farbe</span>
        <v-tooltip bottom max-width="280">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" x-small class="ml-1">{{ mdiInformationOutline }}</v-icon>
          </template>
          <span>Grundfarbe der Beleuchtung des Drehschalters.</span>
        </v-tooltip>
        <reset-icon :setting="color" @clear="$emit('clear', color.key)" @set-here="$emit('set-here', color.key)" />
      </div>
      <v-slider
        v-if="!ecoActive"
        :value="hue"
        @input="val => $emit('input', { key: color.key, value: hueToHex(val) })"
        :min="0"
        :max="360"
        dense
        thumb-label="always"
        class="mt-2 color-gradient-slider"
        :thumb-color="color.currentValue"
      >
        <template v-slot:thumb-label></template>
      </v-slider>
      <div v-else class="text-caption text--disabled mt-2">
        Der Eco-Modus ist aktiviert, der Leuchtring ist ausgeschaltet.
      </div>

      <div class="section-divider"></div>

      <div class="d-flex align-center">
        <v-checkbox
          :input-value="mode.currentValue"
          true-value="off"
          false-value="static"
          @change="$emit('input', { key: mode.key, value: $event })"
          dense
          hide-details
          class="mt-0 pt-0"
        >
          <template #label>
            <span class="text-body-2">Eco-Modus aktivieren und LED-Ring ausschalten</span>
            <v-tooltip bottom max-width="280">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" x-small class="ml-1">{{ mdiInformationOutline }}</v-icon>
              </template>
              <span>Damit kann insbesondere bei Akku-betriebenen Geräten die Laufzeit verlängert werden.</span>
            </v-tooltip>
          </template>
        </v-checkbox>
        <reset-icon :setting="mode" @clear="$emit('clear', mode.key)" @set-here="$emit('set-here', mode.key)" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiInformationOutline } from '@mdi/js'
import { hexToHue, hsl2Hex } from '@/lib/color-tools'
import ResetIcon from '@/components/device/ResetIcon'

export default {
  name: 'LedRingGroup',
  components: { ResetIcon },
  props: {
    color: {
      type: Object,
      required: true,
    },
    mode: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      mdiInformationOutline,
    }
  },
  computed: {
    ecoActive () {
      return this.mode.currentValue === 'off'
    },
    hue () {
      return hexToHue(this.color.currentValue)
    },
  },
  methods: {
    hueToHex (hue) {
      return hsl2Hex(hue, 100, 50)
    },
  },
}
</script>

<style scoped>
.section-divider {
  height: 1px;
  background: rgba(0, 0, 0, .08);
  margin: 20px 0;
}
/deep/ .color-gradient-slider .v-slider__track-container {
  background: linear-gradient(
    to right,
    #ff0000 0%,
    #ffff00 17%,
    #00ff00 33%,
    #00ffff 50%,
    #0000ff 67%,
    #ff00ff 83%,
    #ff0000 100%
  );
  height: 5px;
}
/deep/ .color-gradient-slider .v-slider__track-container > div {
  background-color: transparent !important;
}
</style>
